import type { MouseEvent } from 'react';
import cx from 'clsx';

import useNonLoginPopupStore from '~/store/global/useNonLoginPopupStore';

interface Props {
  className?: string;
}
const NonLoginECouponProductPurchaseButton = ({ className }: Props) => {
  const { openPopup } = useNonLoginPopupStore();

  const onClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    e.preventDefault();

    openPopup();
  };
  return (
    <button
      type="button"
      className={cx([
        'block w-[62px] h-[28px] bg-gray-000 text-primary-regular border-[1px] border-primary-regular rounded-lg mb-8 mr-8 typo-paragraph100-semibold whitespace-nowrap',
        className,
      ])}
      onClick={onClick}
    >
      바로구매
    </button>
  );
};

export default NonLoginECouponProductPurchaseButton;
